<div class="acceptance-buttons">
    <app-button [ngClass]="acceptBtnClass" classes="small" text="AGREE" (onClick)="onReview($event, true)">
    </app-button>
    <app-button [ngClass]="denyBtnClass" classes="small" text="DISAGREE" (onClick)="onReview($event, false)"></app-button>
</div>